/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [采购订单列表↗](http://yapi.yishou.com/project/128/interface/api/29831) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `采购工作台(不含触达，开单)`, `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/list`
 * @更新时间 `2022-03-21 18:38:07`
 */
const listRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/list",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: [
      "pagesize",
      "cg_type",
      "create_time[0]",
      "create_time[1]",
      "page",
      "is_pc",
      "is_dispense",
    ],
    properties: {
      "order_owner[]": { type: "string", description: "订单负责人" },
      pagesize: { type: "string", description: "" },
      cg_type: { type: "string", description: "" },
      "create_time[0]": { type: "string", description: "" },
      "create_time[1]": { type: "string", description: "" },
      page: { type: "string", description: "" },
      is_pc: { type: "string", description: "" },
      is_dispense: {
        type: "string",
        description: "是否小店分发 0 全部 1 是 2 否",
      },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      status: {
        type: "array",
        items: {
          type: "object",
          properties: {
            key: { type: "number" },
            label: { type: "string" },
            count: { type: "number" },
            price: { type: "number" },
          },
          required: ["key", "label", "count", "price"],
        },
      },
      dataStatis: {
        type: "object",
        properties: {
          planPrice: { type: "string" },
          cWwaitCheckPrice: { type: "string" },
          waitPayPrice: { type: "string" },
          payPrice: { type: "string" },
          cgWaitCheckPrice: { type: "string" },
        },
      },
      optionsStatus: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      optionsCgType: {
        type: "object",
        properties: {
          "0": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "1": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "3": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "4": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "6": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "7": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "8": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "9": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "10": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "11": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
          "127": {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
          },
        },
      },
      optionsPg: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "string" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      optionsPayTools: {
        type: "array",
        items: {
          type: "object",
          properties: { label: { type: "string" }, key: { type: "number" } },
          required: ["label", "key"],
        },
      },
      optionsOrderType: {
        type: "array",
        items: {
          type: "object",
          properties: { label: { type: "string" }, key: { type: "string" } },
          required: ["label", "key"],
        },
      },
      page: { type: "number" },
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            woid: { type: "number" },
            supply_name: { type: "string" },
            supply_id: { type: "number" },
            market_nikename: { type: "string" },
            supply_city: { type: "string" },
            cg_type: { type: "number" },
            prepay_people: { type: "string" },
            status: { type: "number" },
            pgname: { type: "string" },
            create_price: { type: "string" },
            pay_price: { type: "string" },
            diff_price: { type: "string" },
            ded_activity_fee: {
              type: "string",
              tag: "爆版4.22.0",
              description: "商品抵扣金额(已有字段)",
            },
            create_admin: { type: "number" },
            owner_admin_name: { type: "string" },
            create_time: { type: "string" },
            pay_time: { type: "string" },
            pay_admin: { type: "string" },
            note: { type: "string" },
            check_desc: { type: "string" },
            pg_member_name: { type: "string" },
            sum_num: { type: "string" },
            wdd_num: { type: "number" },
            dk_num: { type: "string" },
            dk_amount: { type: "string" },
            source: { type: "number" },
            activity_price: { type: "string" },
            wcg_order_pay_tool: { type: "string" },
            service_fee: { type: "string" },
            service_fee_rate: { type: "string" },
            refund_service_fee_rate: { type: "string" },
            refund_service_fee: { type: "string" },
            order_type: { type: "string" },
            create_admin_name: { type: "null" },
            sir_num: { type: "number" },
            status_label: { type: "string" },
            cg_type_label: { type: "string" },
            source_text: { type: "string" },
            true_price: { type: "string" },
            is_dispense: {
              type: "string",
              description: "是否小店分发  0 否 1 是",
            },
            is_dispense_text: {
              type: "string",
              description: "小店分发（文字描述，如果不是，则为空）",
            },
            activity_fee: {
              type: "string",
              tag: "爆版4.22.0",
              description: "活动费用抵扣金额(新字段)",
            },
            "": { type: "string" },
          },
          required: ["is_dispense", "is_dispense_text", "activity_fee", ""],
        },
      },
      count: { type: "number" },
      owner_option: {
        type: "array",
        items: {
          type: "object",
          properties: { label: { type: "string" }, value: { type: "string" } },
          required: ["label", "value"],
        },
      },
    },
  },
  requestFunctionName: "list",
  extraInfo: {},
};
/**
 * 接口 [采购订单列表↗](http://yapi.yishou.com/project/128/interface/api/29831) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `采购工作台(不含触达，开单)`, `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/list`
 * @更新时间 `2022-03-21 18:38:07`
 */
export const list = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(listRequestConfig, requestData), ...args);
};
list.requestConfig = listRequestConfig;
/**
 * 接口 [采购报表↗](http://yapi.yishou.com/project/128/interface/api/33135) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/GetDataOfWcg`
 * @更新时间 `2022-02-26 10:30:53`
 */
const getDataOfWcgRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/GetDataOfWcg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    $schema: "http://json-schema.org/draft-04/schema#",
    type: "object",
    properties: {
      isBetaTest: { type: "number" },
      supply_name: { type: "string" },
      appType: { type: "string" },
      type: { type: "string" },
      version: { type: "string" },
      is_dispense: {
        type: "string",
        description: "是否小店分发  0 全部 1 是 2否",
      },
    },
    required: ["is_dispense"],
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      pg_list: {
        type: "array",
        items: {
          type: "object",
          properties: { pgid: { type: "string" }, pgname: { type: "string" } },
          required: ["pgid", "pgname"],
        },
      },
      owner_option: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
      },
      wcg_order_ofsupply: {
        type: "array",
        items: {
          type: "object",
          properties: {
            supply_id: { type: "string" },
            cg_time: { type: "string" },
            supply_name: { type: "string" },
            create_name: { type: "string" },
            cg_type: { type: "string" },
            all_num: { type: "string" },
            all_price: { type: "string" },
            pgid: { type: "string" },
            pgname: { type: "string" },
            owner_admin_name: { type: "string" },
            market_name: { type: "string" },
            wcg_order_source: { type: "string" },
            purchase_spu_num: { type: "string" },
            cg_type_text: { type: "string" },
            owe_num: { type: "string" },
            owe_price: { type: "string" },
            rj_owe_num: { type: "string" },
            rj_owe_price: { type: "string" },
            num: { type: "string" },
            price: { type: "string" },
            ded_num: { type: "string" },
            ded_price: { type: "string" },
            use_ded_num: { type: "string" },
            use_ded_price: { type: "string" },
            unded_num: { type: "string" },
            unded_price: { type: "string" },
            refund_num: { type: "number" },
            refund_price: { type: "string" },
            bad_num: { type: "number" },
            bad_price: { type: "string" },
            hexiao_num: { type: "number" },
            hexiao_price: { type: "string" },
            baddebt_num: { type: "string" },
            baddebt_price: { type: "string" },
            exchange_num: { type: "number" },
            exchange_price: { type: "string" },
            ded_status: { type: "string" },
            broken_num: { type: "number" },
            broken_price: { type: "string" },
            broken_num_rj: { type: "number" },
            broken_price_rj: { type: "string" },
            cancel_num: { type: "number" },
            cancel_price: { type: "string" },
            create_time: { type: "string" },
            rj_wait_receive_num: { type: "number" },
            rj_wait_receive_price: { type: "string" },
            rj_wait_stockin_num: { type: "number" },
            rj_wait_stockin_price: { type: "string" },
            diff_num: { type: "number" },
          },
        },
      },
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            woid: { type: "string" },
            cg_time: { type: "string" },
            supply_id: { type: "string" },
            supply_name: { type: "string" },
            create_name: { type: "string" },
            cg_type: { type: "string" },
            all_num: { type: "string" },
            all_price: { type: "string" },
            pgid: { type: "string" },
            pgname: { type: "string" },
            owner_admin_name: { type: "string" },
            market_name: { type: "string" },
            wcg_order_source: { type: "string" },
            purchase_spu_num: { type: "string" },
            create_time: { type: "string" },
            cg_type_text: { type: "string" },
            owe_num: { type: ["number", "string"] },
            owe_price: { type: "string" },
            rj_owe_num: { type: ["number", "string"] },
            rj_owe_price: { type: "string" },
            num: { type: ["string", "number"] },
            price: { type: "string" },
            ded_num: { type: ["number", "string"] },
            ded_price: { type: "string" },
            use_ded_num: { type: ["number", "string"] },
            use_ded_price: { type: "string" },
            unded_num: { type: ["number", "string"] },
            unded_price: { type: "string" },
            refund_num: { type: "number" },
            refund_price: { type: "string" },
            bad_num: { type: "number" },
            bad_price: { type: "string" },
            hexiao_num: { type: "number" },
            hexiao_price: { type: "string" },
            baddebt_num: { type: ["number", "string"] },
            baddebt_price: { type: "string" },
            exchange_num: { type: "number" },
            exchange_price: { type: "string" },
            ded_status: { type: ["number", "string"] },
            broken_num: { type: "number" },
            broken_price: { type: "string" },
            broken_num_rj: { type: "number" },
            broken_price_rj: { type: "string" },
            cancel_num: { type: "number" },
            cancel_price: { type: "string" },
            rj_wait_receive_num: { type: "number" },
            rj_wait_receive_price: { type: "string" },
            rj_wait_stockin_num: { type: "number" },
            rj_wait_stockin_price: { type: "string" },
            diff_num: { type: "number" },
            is_dispense: {
              type: "string",
              description: "是否小店分发  0 否 1是",
            },
            is_dispense_text: { type: "string", description: "文字描述" },
          },
          required: [
            "woid",
            "cg_time",
            "supply_id",
            "supply_name",
            "create_name",
            "cg_type",
            "all_num",
            "all_price",
            "pgid",
            "pgname",
            "owner_admin_name",
            "market_name",
            "wcg_order_source",
            "purchase_spu_num",
            "create_time",
            "cg_type_text",
            "owe_num",
            "owe_price",
            "rj_owe_num",
            "rj_owe_price",
            "num",
            "price",
            "ded_num",
            "ded_price",
            "use_ded_num",
            "use_ded_price",
            "unded_num",
            "unded_price",
            "refund_num",
            "refund_price",
            "bad_num",
            "bad_price",
            "hexiao_num",
            "hexiao_price",
            "baddebt_num",
            "baddebt_price",
            "exchange_num",
            "exchange_price",
            "ded_status",
            "broken_num",
            "broken_price",
            "broken_num_rj",
            "broken_price_rj",
            "cancel_num",
            "cancel_price",
            "rj_wait_receive_num",
            "rj_wait_receive_price",
            "rj_wait_stockin_num",
            "rj_wait_stockin_price",
            "diff_num",
            "is_dispense",
            "is_dispense_text",
          ],
        },
      },
    },
  },
  requestFunctionName: "getDataOfWcg",
  extraInfo: {},
};
/**
 * 接口 [采购报表↗](http://yapi.yishou.com/project/128/interface/api/33135) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/GetDataOfWcg`
 * @更新时间 `2022-02-26 10:30:53`
 */
export const getDataOfWcg = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getDataOfWcgRequestConfig, requestData), ...args);
};
getDataOfWcg.requestConfig = getDataOfWcgRequestConfig;
/**
 * 接口 [采购单商品列表↗](http://yapi.yishou.com/project/128/interface/api/33136) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/getGoodsList`
 * @更新时间 `2022-03-01 14:25:43`
 */
const getGoodsListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/getGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["is_dispense"],
    properties: {
      is_dispense: {
        type: "string",
        description: "是否小店分发  0 全部 1 是 2否",
      },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      optionsStatus: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      optionsPg: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "string" }, label: { type: "string" } },
          required: ["key", "label"],
        },
      },
      owner_option: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
      },
      ptype_option: {
        type: "array",
        items: {
          type: "object",
          properties: {
            value: { type: ["number", "string"] },
            label: { type: "string" },
          },
          required: ["value", "label"],
        },
      },
      page: { type: "number" },
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            cg_type: { type: "string" },
            woid: { type: "string" },
            woiid: { type: "string" },
            supply_name: { type: "string" },
            supply_id: { type: "string" },
            supply_city: { type: "string" },
            market_nikename: { type: "string" },
            status: { type: "string" },
            pgname: { type: "string" },
            create_time: { type: "string" },
            owner_admin_name: { type: "string" },
            pay_time: { type: "string" },
            pay_admin: { type: "string" },
            note: { type: "string" },
            check_desc: { type: "string" },
            goods_name: { type: "string" },
            goods_kh: { type: "string" },
            goods_no: { type: "string" },
            plan_num: { type: ["string", "null"] },
            dk_num: { type: "string" },
            num: { type: ["string", "null"] },
            price: { type: "string" },
            co_val: { type: "string" },
            si_val: { type: "string" },
            planid: { type: ["string", "null"] },
            wcg_plan_ptype: { type: "string" },
            wcg_order_type: { type: "string" },
            goods_return_day: { type: "string" },
            ade_key: { type: ["string", "null"] },
            service_fee_rate: { type: "string" },
            refund_service_fee_rate: { type: "string" },
            woi_num: { type: "string" },
            status_label: { type: "string" },
            activity_fee: { type: "number" },
            service_fee: { type: "number" },
            refund_service_fee: { type: "number" },
            total: { type: "string" },
            true_total: { type: "string" },
            is_pre_storage: { type: "number" },
            is_dispense: {
              type: "string",
              description: "是否小店分发  0 否 1是",
            },
            is_dispense_text: { type: "string", description: "文字描述" },
          },
          required: [
            "cg_type",
            "woid",
            "woiid",
            "supply_name",
            "supply_id",
            "supply_city",
            "market_nikename",
            "status",
            "pgname",
            "create_time",
            "owner_admin_name",
            "pay_time",
            "pay_admin",
            "note",
            "check_desc",
            "goods_name",
            "goods_kh",
            "goods_no",
            "plan_num",
            "dk_num",
            "num",
            "price",
            "co_val",
            "si_val",
            "planid",
            "wcg_plan_ptype",
            "wcg_order_type",
            "goods_return_day",
            "ade_key",
            "service_fee_rate",
            "refund_service_fee_rate",
            "woi_num",
            "status_label",
            "activity_fee",
            "service_fee",
            "refund_service_fee",
            "total",
            "true_total",
            "is_pre_storage",
            "is_dispense",
            "is_dispense_text",
          ],
        },
      },
      count: { type: "number" },
    },
  },
  requestFunctionName: "getGoodsList",
  extraInfo: {},
};
/**
 * 接口 [采购单商品列表↗](http://yapi.yishou.com/project/128/interface/api/33136) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/getGoodsList`
 * @更新时间 `2022-03-01 14:25:43`
 */
export const getGoodsList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGoodsListRequestConfig, requestData), ...args);
};
getGoodsList.requestConfig = getGoodsListRequestConfig;
/**
 * 接口 [采购核单↗](http://yapi.yishou.com/project/128/interface/api/33138) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/SampleGoodsPlan/sgpWaitCgListGet`
 * @更新时间 `2022-03-01 10:05:46`
 */
const sgpWaitCgListGetRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SampleGoodsPlan/sgpWaitCgListGet",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["ptype"],
    properties: { ptype: { type: "string", description: "199 小店分发" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      supply_list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            planid: { type: "string" },
            supply_id: { type: "string" },
            supply_name: { type: "string" },
            supply_city: { type: "string" },
            market_nikename: { type: "string" },
            supply_floor: { type: "string" },
            settle_type: { type: "string" },
            pgname: { type: "string" },
            pgid: { type: "string" },
            pg_member_name: { type: "string" },
            supply_purchase_status: { type: "string" },
            create_time: { type: "string" },
            ptype: { type: "string" },
            order_ability_status: { type: "string" },
            package_num: { type: "number" },
            wpc_num: { type: "number" },
            wait_cg_num: { type: "string" },
            wait_cg_total: { type: "string" },
            cg_num: { type: ["number", "string"] },
            plan_source: { type: "string" },
            is_dispense: {
              type: "string",
              description: "是否小店分发  0 否 1是",
            },
            is_dispense_text: { type: "string", description: "文字描述" },
          },
          required: [
            "planid",
            "supply_id",
            "supply_name",
            "supply_city",
            "market_nikename",
            "supply_floor",
            "settle_type",
            "pgname",
            "pgid",
            "pg_member_name",
            "supply_purchase_status",
            "create_time",
            "ptype",
            "order_ability_status",
            "package_num",
            "wpc_num",
            "wait_cg_num",
            "wait_cg_total",
            "cg_num",
            "plan_source",
            "is_dispense_text",
            "is_dispense",
          ],
        },
      },
    },
  },
  requestFunctionName: "sgpWaitCgListGet",
  extraInfo: {},
};
/**
 * 接口 [采购核单↗](http://yapi.yishou.com/project/128/interface/api/33138) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/SampleGoodsPlan/sgpWaitCgListGet`
 * @更新时间 `2022-03-01 10:05:46`
 */
export const sgpWaitCgListGet = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(sgpWaitCgListGetRequestConfig, requestData), ...args);
};
sgpWaitCgListGet.requestConfig = sgpWaitCgListGetRequestConfig;
/**
 * 接口 [开单时获取活动费用商品↗](http://yapi.yishou.com/project/128/interface/api/33153) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/listActivityGoods`
 * @更新时间 `2022-03-09 14:14:14`
 */
const listActivityGoodsRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/listActivityGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    properties: {
      supply_id: { type: "string", description: '"76521"' },
      amount: { type: "string", description: '"2394.02"' },
    },
    additionalProperties: false,
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      goods_list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            activity_time: {
              type: "string",
              description: '"2010-01-22 23:44:50~2010-01-22 23:44:51"',
            },
            goods_name: { type: "string", description: '"商品名"' },
            goods_no: { type: "string", description: '"144456223"' },
            co_si: { type: "string", description: '"颜色/尺码"' },
            sku: { type: "string", description: '"2444123"' },
            activity_fee: { type: "string", description: '"22.0"' },
            num: { type: "string", description: '"2"' },
            order_id: { type: "string", description: '"5323"' },
            activity_id: { type: "string", description: '"98760"' },
            activity_type_text: { type: "string", description: '"活动类型"' },
            activity_name: { type: "string", description: '"活动名称"' },
            activity_fee_amount: { type: "string", description: '"44.00"' },
          },
          additionalProperties: false,
        },
        description:
          '[{"activity_time":"2010-01-22 23:44:50~2010-01-22 23:44:51","goods_name":"商品名","goods_no":"144456223","co_si":"颜色/尺码","sku":"2444123","activity_fee":"22.0","num":"2","order_id":"5323","activity_id":"98760","activity_type_text":"活动类型","activity_name":"活动名称","activity_fee_amount":"44.00"}]',
      },
      saf_ids: {
        type: "array",
        items: { type: "integer", description: "1" },
        description: "[1,2,3,4]",
      },
      activity_fee_amount: { type: "string", description: '"233.23"' },
    },
    additionalProperties: false,
  },
  requestFunctionName: "listActivityGoods",
  extraInfo: {},
};
/**
 * 接口 [开单时获取活动费用商品↗](http://yapi.yishou.com/project/128/interface/api/33153) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/listActivityGoods`
 * @更新时间 `2022-03-09 14:14:14`
 */
export const listActivityGoods = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(listActivityGoodsRequestConfig, requestData), ...args);
};
listActivityGoods.requestConfig = listActivityGoodsRequestConfig;
/**
 * 接口 [提交核单↗](http://yapi.yishou.com/project/128/interface/api/33155) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/submitBilling`
 * @更新时间 `2022-03-19 15:01:18`
 */
const submitBillingRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/submitBilling",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["is_dispense", "saf_ids"],
    properties: {
      is_dispense: { type: "string", description: "是否小店分发 1是  2否" },
      saf_ids: { type: "string", description: "参与活动抵扣的id" },
    },
  },
  responseDataJsonSchema: { type: "object" },
  requestFunctionName: "submitBilling",
  extraInfo: {},
};
/**
 * 接口 [提交核单↗](http://yapi.yishou.com/project/128/interface/api/33155) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/submitBilling`
 * @更新时间 `2022-03-19 15:01:18`
 */
export const submitBilling = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(submitBillingRequestConfig, requestData), ...args);
};
submitBilling.requestConfig = submitBillingRequestConfig;
/**
 * 接口 [获取待开单的商品列表↗](http://yapi.yishou.com/project/128/interface/api/33184) 的 **请求配置**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/getBillingList`
 * @更新时间 `2022-03-04 15:27:37`
 */
const getBillingListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/getBillingList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["is_dispense"],
    properties: {
      is_dispense: {
        type: "string",
        description: "是否小店分发  0 全部 1 是 2否",
      },
    },
  },
  responseDataJsonSchema: {},
  requestFunctionName: "getBillingList",
  extraInfo: {},
};
/**
 * 接口 [获取待开单的商品列表↗](http://yapi.yishou.com/project/128/interface/api/33184) 的 **请求函数**
 *
 * @分类 [采购管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2947)
 * @请求头 `POST /erp/WcgOrder/getBillingList`
 * @更新时间 `2022-03-04 15:27:37`
 */
export const getBillingList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getBillingListRequestConfig, requestData), ...args);
};
getBillingList.requestConfig = getBillingListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/purchaseManagement.js